import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import getData from '../functions/getData'
import { PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER } from '../constants/state'


const mapStateToProps = state => ({
    items: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    order: getData(state, PROGRAM_CLI_MOVIES_ORDER)
})



const hasMovies = () => WrappedComponent => {
    const HasMovies = props => <WrappedComponent {...props} />

    return compose(
        connect(mapStateToProps, null)
    )(HasMovies)
}


export default hasMovies